/**
 * Create a msafe login message to sign
 *
 * @Deprecated: Use SigningMessageHelper instead
 * @returns login message
 */
export function createLoginMessage() {
  return createLoginMessageWithTimestamp(new Date().toUTCString());
}

export function createLoginMessageWithTimestamp(timestamp: string) {
  return `Welcome to MSafe. ${timestamp}`;
}

/**
 * decode login message timestamp
 *
 * @Deprecated: Use SigningMessageHelper instead
 *
 * @param message login message
 * @returns match timestamp
 */
export function decodeLoginMessageTimestamp(message: string) {
  const regex = /Welcome to MSafe. (.+)/;
  const matches = message.match(regex);
  return matches ? matches[1] : undefined;
}

/**
 * @Deprecated: Use SigningMessageHelper instead
 * Create a msafe creation message to sign
 * @param address msafe address
 * @returns msafe account create message
 */
export function createAccountCreationMessage(address: string) {
  return `Create MSafe Account: ${address}`;
}

/**
 * @Deprecated: Use SigningMessageHelper instead
 * Create propose intention sign message
 * @param intention intention
 * @param sn sequence number
 * @returns intention sign message
 */
export function createProposeIntentionMessage(intention: any, sn: number) {
  return JSON.stringify({
    intention,
    sn,
  });
}
